import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Mail, MapPin, Phone, Instagram, Linkedin, Twitter } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormState({
        name: '',
        email: '',
        company: '',
        message: ''
      });
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black" data-id="element-195">
      <Navigation data-id="element-196" />

      <main className="pt-32 pb-24 px-6" data-id="element-197">
        <div className="max-w-7xl mx-auto" data-id="element-198">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-199">
            {/* Left Column: Info */}
            <div data-id="element-200">
              <h1 className="text-6xl md:text-8xl font-black tracking-tighter mb-8" data-id="element-201">
                LET'S <br data-id="element-202" />
                <span className="text-yellow-400" data-id="element-203">WORK</span> <br data-id="element-204" />
                TOGETHER
              </h1>

              <p className="text-xl text-gray-400 mb-12 leading-relaxed max-w-md" data-id="element-205">
                Have a project in mind? We'd love to hear about it. Tell us your
                story and let's build something bold together.
              </p>

              <div className="space-y-8 mb-12" data-id="element-206">
                <div className="flex items-start" data-id="element-207">
                  <Mail className="w-6 h-6 text-yellow-400 mr-4 mt-1" data-id="element-208" />
                  <div data-id="element-209">
                    <h3 className="font-bold uppercase tracking-wider mb-1" data-id="element-210">
                      Email Us
                    </h3>
                    <a href="mailto:hello@kujodo.studio" className="text-gray-400 hover:text-white transition-colors" data-id="element-211">
                      hello@kujodo.studio
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-212">
                  <Phone className="w-6 h-6 text-yellow-400 mr-4 mt-1" data-id="element-213" />
                  <div data-id="element-214">
                    <h3 className="font-bold uppercase tracking-wider mb-1" data-id="element-215">
                      Call Us
                    </h3>
                    <a href="tel:+621234567890" className="text-gray-400 hover:text-white transition-colors" data-id="element-216">
                      +62 123 4567 890
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-217">
                  <MapPin className="w-6 h-6 text-yellow-400 mr-4 mt-1" data-id="element-218" />
                  <div data-id="element-219">
                    <h3 className="font-bold uppercase tracking-wider mb-1" data-id="element-220">
                      Visit Us
                    </h3>
                    <p className="text-gray-400" data-id="element-221">
                      Jl. Kreatif No. 88
                      <br data-id="element-222" />
                      Jakarta Selatan, Indonesia
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex space-x-6" data-id="element-223">
                <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors" data-id="element-224">
                  <Instagram className="w-6 h-6" data-id="element-225" />
                </a>
                <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors" data-id="element-226">
                  <Linkedin className="w-6 h-6" data-id="element-227" />
                </a>
                <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors" data-id="element-228">
                  <Twitter className="w-6 h-6" data-id="element-229" />
                </a>
              </div>
            </div>

            {/* Right Column: Form */}
            <div className="bg-gray-900/50 border border-white/10 p-8 md:p-12" data-id="element-230">
              {isSuccess ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-231">
                  <div className="w-20 h-20 bg-yellow-400 rounded-full flex items-center justify-center mb-6" data-id="element-232">
                    <Mail className="w-10 h-10 text-black" data-id="element-233" />
                  </div>
                  <h3 className="text-3xl font-bold mb-4" data-id="element-234">Message Sent!</h3>
                  <p className="text-gray-400 mb-8" data-id="element-235">
                    Thanks for reaching out. We'll get back to you within 24
                    hours.
                  </p>
                  <Button onClick={() => setIsSuccess(false)} data-id="element-236">
                    Send Another
                  </Button>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-237">
                  <div data-id="element-238">
                    <label htmlFor="name" className="block text-sm font-bold uppercase tracking-wider mb-2 text-gray-400" data-id="element-239">
                      Your Name
                    </label>
                    <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full bg-black border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-700" placeholder="John Doe" data-id="element-240" />
                  </div>

                  <div data-id="element-241">
                    <label htmlFor="email" className="block text-sm font-bold uppercase tracking-wider mb-2 text-gray-400" data-id="element-242">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full bg-black border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-700" placeholder="john@example.com" data-id="element-243" />
                  </div>

                  <div data-id="element-244">
                    <label htmlFor="company" className="block text-sm font-bold uppercase tracking-wider mb-2 text-gray-400" data-id="element-245">
                      Company (Optional)
                    </label>
                    <input type="text" id="company" name="company" value={formState.company} onChange={handleChange} className="w-full bg-black border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-700" placeholder="Your Company Ltd." data-id="element-246" />
                  </div>

                  <div data-id="element-247">
                    <label htmlFor="message" className="block text-sm font-bold uppercase tracking-wider mb-2 text-gray-400" data-id="element-248">
                      Tell us about your project
                    </label>
                    <textarea id="message" name="message" required rows={5} value={formState.message} onChange={handleChange} className="w-full bg-black border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-700 resize-none" placeholder="Project details, timeline, budget..." data-id="element-249" />
                  </div>

                  <button type="submit" disabled={isSubmitting} className="w-full bg-yellow-400 text-black font-bold uppercase tracking-widest py-4 hover:bg-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-250">
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-251" />
    </div>;
}